import { MenuItemUnstyled } from '@mui/base';
import { ReactNode } from 'react';

import { Icon } from '../icon';
import './MenuItemButton.scss';

export interface MenuItemButtonProps {
    label: string | ReactNode;
    onClick?: () => void;
    selected?: boolean;
}

export const MenuItemButton = ({
    onClick,
    label,
    selected,
}: MenuItemButtonProps) => (
    <MenuItemUnstyled
        className={`menu-item--button ${selected ? 'selected' : ''}`}
        onClick={onClick}
        aria-selected={selected}
    >
        {label}

        {selected && <Icon name="checkmark" />}
    </MenuItemUnstyled>
);
